import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ThreeDimModel} from "../../../models/widget/threedimmodel/ThreeDimModel";
import {BaseComponent} from "../../BaseComponent";
import {UserMetricInstance} from "../../../models/user/Metric/UserMetricInstance";
import {FileLoadingWorkflowEnum} from "@aiknow-srl/aik-ngx-3dviewer";
import {PutFileCB} from "../../../ope/storage/PutFileCB";
import {StorageOpeService} from "../../../services/ope/storageOpe.service";
import {DashboardService} from "../../../services/dashboard/dashboard.service";
import {DelFilesCB} from "../../../ope/storage/DelFilesCB";
import {SelectionChangedEvent} from 'devextreme/ui/data_grid';
import {ReorderEvent} from "devextreme/ui/sortable";

@Component({
  selector: 'app-three-dim-model-form',
  templateUrl: './three-dim-model-form.component.html',
  styleUrls: ['./three-dim-model-form.component.css', './three-dim-model-widget.component.css']
})
export class ThreeDimModelFormComponent extends BaseComponent {

  @Input('modelToEdit') modelToEdit?: ThreeDimModel;

  @Output('modelToEdit') modelToEditOutput = new EventEmitter<ThreeDimModel>();

  @Input('popupOpen') popupOpen!: boolean;

  @Output('popupOpen') popupOpenChange = new EventEmitter<boolean>();

  @Output('saveModelRequest') saveModelRequest = new EventEmitter<ThreeDimModel>();

  protected metricList: UserMetricInstance[] = [];

  protected selectedMetricIds: number[] = [];

  protected selectedMesh: number | null = null;

  protected metricsMap: Map<number, UserMetricInstance[]> = new Map();

  protected measurePanelMetrics: UserMetricInstance[] = [];

  protected measurePanelIsSelected: boolean = false;

  protected readonly FileLoadingWorkflowEnum = FileLoadingWorkflowEnum;

  protected loadingWorkflowStatus: any;

  protected storageOpe = inject(StorageOpeService);

  protected dashboardService = inject(DashboardService);

  protected uploadPerc: number = 0;

  protected uploadStage: number = 0;

  protected fileChanged: boolean = false;

  protected localBlob?: File;

  saveCard = () => {
    if (!!this.modelToEdit) {

      if (this.fileChanged) {

        const putFileCB = new PutFileCB();
        putFileCB.i.file = this.localBlob!;

        this.storageOpe.putFile(putFileCB).forEach(
          (value: { perc: number, type: number }) => {
            this.uploadStage = value.type;
            if (this.uploadStage === 1)
              this.uploadPerc = value.perc;
          }
        ).then(
          () => {
            this.uploadStage = 0;
            if (!!this.modelToEdit && !!this.modelToEdit.file && !!this.modelToEdit.file.objKey) {
              const fileToDelete = this.modelToEdit.file;
              if (!!fileToDelete) {
                let delFilesCB = new DelFilesCB();
                delFilesCB.i.files = [fileToDelete];
                this.storageOpe.delFiles(delFilesCB)
                  .then(
                    _ => {

                      this.modelToEdit!.file = putFileCB.o.file;
                      this.modelToEdit!.metricsMap = this.metricsMap;
                      this.modelToEdit!.measurePanelMetrics = this.measurePanelMetrics;
                      this.modelToEditOutput.emit(this.modelToEdit);
                      this.saveModelRequest.emit(this.modelToEdit);
                      delete this.localBlob;
                      this.fileChanged = false;

                      caches.open(this.appService.CACHE_NAME)
                        .then(cache => {
                          return cache.delete(fileToDelete.objKey);
                        })
                    }
                  )
              }
            } else {
              this.modelToEdit!.file = putFileCB.o.file;
              this.modelToEdit!.metricsMap = this.metricsMap;
              this.modelToEdit!.measurePanelMetrics = this.measurePanelMetrics;
              this.modelToEditOutput.emit(this.modelToEdit);
              this.saveModelRequest.emit(this.modelToEdit);
              delete this.localBlob;
              this.fileChanged = false;
            }
          }
        ).catch(
          () => {
            this.uploadStage = 0;
          }
        )
      } else {
        this.uploadStage = 0;
        delete this.localBlob;
        this.modelToEdit!.metricsMap = this.metricsMap;
        this.modelToEdit!.measurePanelMetrics = this.measurePanelMetrics;
        this.modelToEditOutput.emit(this.modelToEdit);
        this.saveModelRequest.emit(this.modelToEdit)
      }
    }
  };

  getMetricIds() {
    if (this.measurePanelIsSelected) {
      this.selectedMetricIds = this.measurePanelMetrics.map((x) => x.id);
    } else {
      if (this.selectedMesh !== null) {
        if (!!this.metricsMap.get(this.selectedMesh))
          this.selectedMetricIds = this.metricsMap.get(this.selectedMesh)!.map(x => x.id);
      }
    }
  }

  getSelectedItems(): void {

    if (this.measurePanelIsSelected) {
      if (!!this.measurePanelMetrics)
        this.selectedMetricIds = this.measurePanelMetrics.map(x => x.id);
      else
        this.selectedMetricIds = []
    } else if (!!this.selectedMesh || this.selectedMesh === 0) {
      if (!!this.metricsMap.get(this.selectedMesh))
        this.selectedMetricIds = this.metricsMap.get(this.selectedMesh)!.map(x => x.id);
      else
        this.selectedMetricIds = [];
    } else {
      this.selectedMetricIds = [];
    }
  }

  applySelection(event: SelectionChangedEvent) {

    if (this.measurePanelIsSelected) {

      // Clicle through event array and check which ones are new (findIndex will return -1)

      event.selectedRowsData.forEach((row: UserMetricInstance) => {
        const metricIndex = this.measurePanelMetrics.findIndex(
          metric => {
            return metric.id === row.id;
          }
        );
        if (metricIndex === -1) {
          this.measurePanelMetrics.push(row);
        }
      });

      // Cicle through panel array and check which ones are removed (findIndex will return -1)

      event.currentDeselectedRowKeys.forEach((rowKey: number) => {
        const rowIndex = this.measurePanelMetrics.findIndex(
          metric => {
            return metric.id === rowKey && metric.deviceId === this.dashboardService.selectedDeviceIds[0];
          }
        );
        if (rowIndex !== -1) {
          this.measurePanelMetrics.splice(rowIndex, 1);
        }
      });

      // Populate keys array

      this.selectedMetricIds = this.measurePanelMetrics.map((x) => x.id);

    } else if (!!this.selectedMesh || this.selectedMesh === 0) {
      if (!this.metricsMap.get(this.selectedMesh))
        this.metricsMap.set(this.selectedMesh, []);

      // Clicle through event array and check which ones are new (findIndex will return -1)

      const selectedMeshMetrics = this.metricsMap.get(this.selectedMesh);
      if (!!selectedMeshMetrics) {
        event.selectedRowsData.forEach((row: UserMetricInstance) => {
          if (!!selectedMeshMetrics) {
            const metricIndex = selectedMeshMetrics.findIndex(
              metric => {
                return metric.id === row.id;
              }
            );
            if (metricIndex === -1) {
              this.metricsMap.get(this.selectedMesh!)!.push(row);
            }
          }
        });

        // Cicle through panel array and check which ones are removed (findIndex will return -1)

        event.currentDeselectedRowKeys.forEach((rowKey: number) => {
          const rowIndex = selectedMeshMetrics.findIndex(
            metric => {
              return metric.id === rowKey && metric.deviceId === this.dashboardService.selectedDeviceIds[0];
            }
          );
          if (rowIndex !== -1) {
            selectedMeshMetrics.splice(rowIndex, 1);
          }
        });

        // Populate keys array

        this.selectedMetricIds = selectedMeshMetrics.map((x) => x.id);

      }

    }
  }

  initForm() {

    this.selectedMesh = null;
    this.loadingWorkflowStatus = null;
    this.metricList = [];
    this.selectedMetricIds = [];
    this.measurePanelIsSelected = false;
    this.uploadPerc = 0;
    this.uploadStage = 0;
    this.fileChanged = false;


    if (!!this.modelToEdit) {
      let metricEntries: [any, any][] = Object.entries(this.modelToEdit?.metricsMap);

      metricEntries.forEach((entry) => {
        if (!isNaN(entry[0]) && entry[0] !== null) {
        }
        entry[0] = Number(entry[0])
      });

      this.metricsMap = new Map<number, UserMetricInstance[]>(metricEntries);
      this.measurePanelMetrics = this.modelToEdit?.measurePanelMetrics;
    } else {
      this.metricsMap = new Map<number, UserMetricInstance[]>();
      this.measurePanelMetrics = [];
    }
  }

  deleteMeasure(measureId: number, mesh: number) {
    if (mesh >= 0) {
      if (!!this.metricsMap.get(mesh)) {
        let idxToDelete = this.metricsMap.get(mesh)!.findIndex(x => x.id === measureId);
        if (idxToDelete !== -1) {
          this.metricsMap.get(mesh)!.splice(idxToDelete, 1);
        }
        this.selectedMetricIds = this.selectedMetricIds.filter(x => x !== measureId);
      }
    } else {
      let idxToDelete = this.measurePanelMetrics.findIndex(x => x.id === measureId);
      if (idxToDelete !== -1) {
        this.measurePanelMetrics.splice(idxToDelete, 1);
      }
      this.selectedMetricIds = this.selectedMetricIds.filter(x => x !== measureId);
    }
  }

  loadFile() {
    const input = document.createElement('input');
    input.type = 'file';
    input.onchange = (event: any) => {
      if (!!event.target && !!event.target.files) {

        const file: File = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          if (!!readerEvent.target) {
            this.fileChanged = true;
            if (!!this.modelToEdit) {
              this.localBlob = file;
              this.modelToEdit.fileName = file.name.split('.')[0];
            }
          }
        }
      }
    };
    input.click();
    this.metricsMap = new Map();
  }


  reorderPanelMetrics(event: ReorderEvent) {
    this.array_move(this.measurePanelMetrics, event.fromIndex, event.toIndex);
  }

}
